export class ReqVisit{
  constructor(public idCliente: string, public idPromocion: number, public fecha: Date) {
  }
}
